export const colorPrimary = "#437A7E"
export const colorSecondary = "#6AACAC"
export const colorTertiary = "#505B61"
export const colorAccent = "#BCD5C2"
export const colorSec1 = "#B7AA9B"
export const colorSec2 = "#D8E3E9"
export const colorSec3 = "#A5C0C4"
export const grey = "#65646A"
export const white = "#fff"
export const black = "#000"
export const strongRed = "#f00"

export default {
  colorPrimary,
  colorSecondary,
  colorTertiary,
  colorAccent,
  colorSec1,
  colorSec2,
  colorSec3,
  grey,
  white,
  black,
  strongRed,
}
